import * as React from 'react';
import Button from '../../../components/Button';
import Dialog from '../../../components/Dialog';
import styled from '../../../styled-components';
import { HiringManager } from '../types';
import ShareWithHiringManagerForm from './ShareWithHiringManagerForm';

const Wrapper = styled.div``;

interface ShareWithHiringManagerButtonState {
    showDataForm: boolean;
}

interface ShareWithHiringManagerButtonProps {
    hiringManagers: HiringManager[];
    onHiringManagersUpdate(hiringManagers: HiringManager[]);
    onShare: (hiringManager: HiringManager) => void;
}

class ShareWithHiringManagerButton extends React.Component<
    ShareWithHiringManagerButtonProps,
    ShareWithHiringManagerButtonState
> {
    constructor(props: ShareWithHiringManagerButtonProps) {
        super(props);
        this.state = { showDataForm: false };
        this.toggleShowDataForm = this.toggleShowDataForm.bind(this);
        this.onHiringManagersUpdate = this.onHiringManagersUpdate.bind(this);
        this.handleOnShare = this.handleOnShare.bind(this);
    }

    private toggleShowDataForm() {
        this.setState({ showDataForm: !this.state.showDataForm });
    }

    private onHiringManagersUpdate(hiringManagers: HiringManager[]) {
        this.props.onHiringManagersUpdate(hiringManagers);
    }

    private handleOnShare(hiringManager: HiringManager) {
        this.props.onShare(hiringManager);
        this.toggleShowDataForm();
    }

    public render() {
        return (
            <Wrapper>
                <Button onClick={this.toggleShowDataForm}>Share with hiring manager</Button>
                {this.state.showDataForm && (
                    <Dialog toggle={this.toggleShowDataForm}>
                        <ShareWithHiringManagerForm
                            onShare={this.handleOnShare}
                            hiringManagers={this.props.hiringManagers}
                            onUpdateHiringManagers={this.onHiringManagersUpdate}
                        />
                    </Dialog>
                )}
            </Wrapper>
        );
    }
}

export default ShareWithHiringManagerButton;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/ShareWithHiringManagerButton.tsx